import React, { useState } from "react";
import Lottie from "lottie-react";
import pagenotfound from "../assets/lottiefiles/pagenotfound.json";

export default function Animatedicons({ name }) {
  const [statusList] = useState({
    error: {
      source: pagenotfound,
    },
  });
  if (name) {
    return (
      <Lottie
        animationData={statusList[name]?.source}
        autoplay
        className="animatedIcon"
      />
    );
  }
  return null;
}
